<script>
    import { onMount, createEventDispatcher } from "svelte";
    import Conexoes from "../Classes/Conexoes";
    import CaixaDeDialogo from "../componentes_basicos/CaixaDeDialogo.svelte";
    import LoadingTela from "../componentes_basicos/LoadingTela.svelte";
    import Constantes from "../Classes/Constantes";

    const dispatch = createEventDispatcher();

    export let showModal = false;
    export let params;
    
    let diaNascimento = "";
    let mesNascimento = "";
    let anoNascimento = "";
    let horarios = [];
    let apagavel = false; 
    let horariosSelecionados = []; 
    let mensagemConfirmacao = ""; 
    let mensagemConfirmacao2 = ""; 
    const conexao = new Conexoes();
    let mostrandoModal = false; 

    let horarioSelecionado = null; 
    let mostrarCaixaDialogo = false; 
    let mensagemCaixaDialogo = ""; 
    let isLoading = false; 
    
    // Filtro: 0 = Presencial, 1 = Online
    export let ordem=0;
    export let filtroOnline = 0; 

    // --- CORREÇÃO AQUI: Variável Reativa ---
    // O Svelte recalcula isso automaticamente quando horarios ou filtroOnline mudam
    $: horariosFiltrados = horarios.filter(h => h.online == filtroOnline);

    const diasDaSemana = [
        "Domingo",
        "Segunda-feira",
        "Terça-feira",
        "Quarta-feira",
        "Quinta-feira",
        "Sexta-feira",
        "Sábado",
    ];

    let dadosAgendamento = {
        nome: "",
        ddd: "",
        telefone: "",
        email: "",
        data: "",
        hora: "",
        id: "",
        dataNascimento: "",
        online: 0 
    };

    $: horarioSelecionadoId = horarioSelecionado?.id; 

    onMount(async () => {
        if (params === "true") {
            apagavel = true; 
            showModal = true; 
        }
        await carregarHorarios(); 
    });

    async function carregarHorarios() {
        isLoading = true; 
        const resposta = await conexao.conecta("listar_horarios.php");
        isLoading = false; 
        if (resposta) {
            horarios = resposta; 
        } else {
            console.error("Erro ao carregar horários.");
            horarios = []; 
        }
    }

    function handleSelecaoHorario(id) {
        if (horariosSelecionados.includes(id)) {
            horariosSelecionados = horariosSelecionados.filter((h) => h !== id);
        } else {
            horariosSelecionados = [...horariosSelecionados, id];
        }
    }

    async function confirmarAgendamento() {
        mensagemConfirmacao = "";  
        mensagemConfirmacao2 = "";

        if (!dadosAgendamento.nome) {
            mensagemConfirmacao2 = "Por favor, preencha o nome completo.";
            mostrarCaixaDialogo = true;
            return;
        }
        if (!dadosAgendamento.dataNascimento) {
            mensagemConfirmacao2 = "Por favor, preencha a data de nascimento.";
            mostrarCaixaDialogo = true;
            return;
        }
        if (!dadosAgendamento.ddd || !/^\d{2}$/.test(dadosAgendamento.ddd)) {
            mensagemConfirmacao2 = "Por favor, preencha o DDD corretamente (2 dígitos).";
            mostrarCaixaDialogo = true;
            return;
        }

        if (!dadosAgendamento.telefone || !/^\d{9}$/.test(dadosAgendamento.telefone)) {
            mensagemConfirmacao2 = "Por favor, preencha o telefone corretamente (9 dígitos).";
            mostrarCaixaDialogo = true;
            return;
        }

        let tipoTexto = filtroOnline === 1 ? "ONLINE" : "PRESENCIAL";

        mensagemCaixaDialogo = `Confirmar agendamento <b>${tipoTexto}</b> para ${dadosAgendamento.nome} em ${formatarData(dadosAgendamento.data)} (${getDiaDaSemana(dadosAgendamento.data)}) às ${dadosAgendamento.hora}?
        <br>Telefone: (${dadosAgendamento.ddd}) ${dadosAgendamento.telefone}<br>Data de nascimento: ${formatarData(dadosAgendamento.dataNascimento)}<br>E-mail: ${dadosAgendamento.email || "Não informado"}`;

        mostrarCaixaDialogo = true; 
    }

    async function apagarHorarios() {
        if (horariosSelecionados.length === 0) {
            mensagemCaixaDialogo = "Selecione pelo menos um horário para apagar.";
            mostrarCaixaDialogo = true; 
            return;
        }

        mensagemCaixaDialogo = `Tem certeza que deseja apagar os horários selecionados?`;
        mostrarCaixaDialogo = true; 
    }

    function getDiaDaSemana(dataString) {
        const [ano, mes, dia] = dataString.split("-").map(Number);
        const data = new Date(ano, mes - 1, dia); 
        return diasDaSemana[data.getDay()];
    }

    function formatarData(dataString) {
        const [ano, mes, dia] = dataString.split("-").map(Number);
        const data = new Date(ano, mes - 1, dia); 
        return `${dia.toString().padStart(2, "0")}/${mes.toString().padStart(2, "0")}/${ano}`;
    }

    function agruparPorData(listaHorarios) {
        const grupos = {};
        listaHorarios.forEach((horario) => {
            const data = horario.inicio.split(" ")[0];
            if (!grupos[data]) {
                grupos[data] = [];
            }
            grupos[data].push(horario);
        });
        return grupos;
    }

    async function confirmarAcao() {
        mensagemConfirmacao2 = "";
        mensagemConfirmacao = "";

        if (horariosSelecionados.length > 0 && apagavel) {
            isLoading = true;
            const resposta = await conexao.conecta("apagar_horarios.php", {
                body: { ids: horariosSelecionados },
            });
            isLoading = false;

            if (resposta.mensagem) {
                mensagemCaixaDialogo = resposta.mensagem;
                mostrarCaixaDialogo = true; 
                await carregarHorarios();  
                horariosSelecionados = [];  
            } else {
                mensagemCaixaDialogo = "Erro ao apagar horários.";
                mostrarCaixaDialogo = true;
            }
        } else if (horarioSelecionado) { 
            isLoading = true;
            const telefoneCompleto = dadosAgendamento.ddd + dadosAgendamento.telefone;
            const resposta = await conexao.conecta("agendar.php", {
                body: {
                    ...dadosAgendamento,
                    telefone: telefoneCompleto,
                },
            });
            isLoading = false;

            if (resposta.sucesso) {
                carregarHorarios();
                mensagemConfirmacao = resposta.mensagem;
                mostrarCaixaDialogo = false; 
                
                // *************** GOOGLE ADS ***************
               if (typeof window.gtag !== 'undefined') {
          window.gtag('event', 'conversion', {
               'send_to': 'AW-964653439/pMNBCLqUjuIbEP_i_csD',
          });
        }
                // *************** FIM GOOGLE ADS ***************

            } else {
                mensagemConfirmacao2 = "Erro ao agendar horário: " + (resposta.erro || "Erro desconhecido");
                mostrarCaixaDialogo = true;  
            }
        }
        mostrarCaixaDialogo = false; 
    }

    function fecharCaixaDialogo() {
        mensagemCaixaDialogo = "";
        mostrarCaixaDialogo = false;
    }

    function abrirModalAgendamento(horario) {
        horarioSelecionado = horario;
        dadosAgendamento.data = horario.inicio.split(" ")[0];
        dadosAgendamento.hora = horario.inicio.split(" ")[1];
        dadosAgendamento.id = horario.id;
        dadosAgendamento.online = horario.online; 
        mostrandoModal = true; 
    }

    function fecharModal() {
        mostrandoModal = false; 
        dadosAgendamento = {
            nome: "",
            ddd: "",
            telefone: "",
            email: "",
            data: "",
            hora: "",
            id: "",
            dataNascimento: "",
            online: 0
        };
        horarioSelecionado = null;
        mensagemConfirmacao = "";
        mensagemConfirmacao2 = "";
        mensagemCaixaDialogo = "";
        horarios = [];
        window.location.reload();
        Fechar();
    }

    function Fechar() {
        dispatch("close");
        showModal = false; 
    }
</script>

<LoadingTela {isLoading} />

{#if showModal}
    <div class="agendamento-modal-overlay">
        <div class="modal-dialog agendamento-modal-content">
            <div class="modal-content">
                <div class="modal-header">
    
                    <div class="row w-100">
                        <div style="display: flex; justify-content: flex-end; padding: 0.5rem;">
                            {#if !apagavel}
                                <button
                                    type="button"
                                    class="btn btn-danger"
                                    style="width: 32px; height: 32px; padding: 0; display: flex; align-items: center; justify-content: center;"
                                    on:click={Fechar}
                                    aria-label="Fechar"
                                >
                                    ✕
                                </button>
                            {/if}
                        </div>
                    </div>          

                    <h5 class="modal-title px-3 pb-2 w-100 text-center">
                        {#if mostrandoModal && !apagavel}
                            Agendar horário: {formatarData(dadosAgendamento.data)} às {dadosAgendamento.hora} ({getDiaDaSemana(dadosAgendamento.data)})
                        {:else}
                            Horários Disponíveis
                        {/if}
                    </h5>

                </div>

                <div class="modal-body">
                    {#if mostrandoModal && !apagavel}
                        <form>
                            <div class="alert alert-success text-center">
                                Você está agendando para: <strong>{filtroOnline === 1 ? 'Atendimento ONLINE' : 'Atendimento PRESENCIAL'}</strong>
                            </div>
                            <div class="mb-3">
                                <label for="nome" class="form-label">Nome Completo</label>
                                <input type="text" class="form-control" id="nome" bind:value={dadosAgendamento.nome} />
                            </div>
                            <div class="mb-3 d-flex">
                                <div class="me-2">
                                    <label for="diaNascimento" class="form-label">Dia</label>
                                    <select
                                        id="diaNascimento"
                                        class="form-control"
                                        bind:value={diaNascimento}
                                        on:change={() => {
                                            dadosAgendamento.dataNascimento = `${anoNascimento}-${mesNascimento.padStart(2, "0")}-${diaNascimento.padStart(2, "0")}`;
                                        }}
                                    >
                                        <option value="">Dia</option>
                                        {#each Array(31).fill(0).map((_, i) => i + 1) as d}
                                            <option value={d.toString().padStart(2, "0")}>{d}</option>
                                        {/each}
                                    </select>
                                </div>

                                <div class="me-2">
                                    <label for="mesNascimento" class="form-label">Mês</label>
                                    <select
                                        id="mesNascimento"
                                        class="form-control"
                                        bind:value={mesNascimento}
                                        on:change={() => {
                                            dadosAgendamento.dataNascimento = `${anoNascimento}-${mesNascimento.padStart(2, "0")}-${diaNascimento.padStart(2, "0")}`;
                                        }}
                                    >
                                        <option value="">Mês</option>
                                        {#each Array(12).fill(0).map((_, i) => i + 1) as m}
                                            <option value={m.toString().padStart(2, "0")}>{m}</option>
                                        {/each}
                                    </select>
                                </div>

                                <div>
                                    <label for="anoNascimento" class="form-label">Ano</label>
                                    <select
                                        id="anoNascimento"
                                        class="form-control"
                                        bind:value={anoNascimento}
                                        on:change={() => {
                                            dadosAgendamento.dataNascimento = `${anoNascimento}-${mesNascimento.padStart(2, "0")}-${diaNascimento.padStart(2, "0")}`;
                                        }}
                                    >
                                        <option value="">Ano</option>
                                        {#each Array(new Date().getFullYear() - 1900 + 1).fill(0).map((_, i) => new Date().getFullYear() - i) as ano}
                                            <option value={ano}>{ano}</option>
                                        {/each}
                                    </select>
                                </div>
                            </div>
                            <div class="mb-3 d-flex">
                                <div class="me-2">
                                    <label for="ddd" class="form-label">DDD</label>
                                    <input type="tel" class="form-control" id="ddd" maxlength="2" bind:value={dadosAgendamento.ddd} />
                                </div>
                                <div class="flex-grow-1">
                                    <label for="telefone" class="form-label">Telefone (9 dígitos)</label>
                                    <input type="tel" class="form-control" id="telefone" maxlength="9" bind:value={dadosAgendamento.telefone}/>
                                </div>
                            </div>

                            <div class="mb-3">
                                <label for="email" class="form-label">E-mail (opcional)</label>
                                <input type="email" class="form-control" id="email" bind:value={dadosAgendamento.email}/>
                            </div>
                        </form>

                    {:else}
                    {#if ordem==0}
                        <div class="d-flex justify-content-center mb-3">
                            <div class="btn-group w-100" role="group">
                                <button 
                                    type="button" 
                                    class="btn {filtroOnline === 0 ? 'btn-primary' : 'btn-outline-primary'}" 
                                    on:click={() => filtroOnline = 0}>
                                    <i class="fas fa-building me-2"></i> Presencial
                                </button>
                                <button 
                                    type="button" 
                                    class="btn {filtroOnline === 1 ? 'btn-primary' : 'btn-outline-primary'}" 
                                    on:click={() => filtroOnline = 1}>
                                    <i class="fas fa-video me-2"></i> Online
                                </button>
                            </div>
                        </div>

                        {:else}

<div class="d-flex justify-content-center mb-3">
                            <div class="btn-group w-100" role="group">
                              
                                <button 
                                    type="button" 
                                    class="btn {filtroOnline === 1 ? 'btn-primary' : 'btn-outline-primary'}" 
                                    on:click={() => filtroOnline = 1}>
                                    <i class="fas fa-video me-2"></i> Online
                                </button>
                                  <button 
                                    type="button" 
                                    class="btn {filtroOnline === 0 ? 'btn-primary' : 'btn-outline-primary'}" 
                                    on:click={() => filtroOnline = 0}>
                                    <i class="fas fa-building me-2"></i> Presencial
                                </button>
                            </div>
                        </div>
                        {/if}

                        <div class="card">
                            <div class="card-body" style="height: 300px; overflow-y: auto;">
                                
                                {#if horariosFiltrados.length > 0}
                                    {@const horariosAgrupados = agruparPorData(horariosFiltrados)}
                                    
                                    {#each Object.entries(horariosAgrupados) as [data, horariosDoDia], i}
                                        <div
                                            class="card mb-2"
                                            style="background-color: {i % 2 === 0 ? '#f8f9fa' : '#e9ecef'}"
                                        >
                                            <div class="card-header font-weight-bold">
                                                {formatarData(data)} ({getDiaDaSemana(data)})
                                            </div>
                                            <ul class="list-group list-group-flush">
                                                {#each horariosDoDia as horario}
                                                    <li
                                                        class="list-group-item d-flex justify-content-between align-items-center"
                                                        on:click={() => abrirModalAgendamento(horario)}
                                                        style="cursor: pointer; background-color: {horarioSelecionadoId === horario.id ? '#d3d3d3' : ''};"
                                                    >
                                                        <span>
                                                            <i class="far fa-clock me-1"></i>
                                                            {horario.inicio.split(" ")[1].substring(0, 5)}
                                                            {#if apagavel}
                                                                <small class="ms-2 text-muted">({horario.online == 1 ? 'Online' : 'Presencial'})</small>
                                                            {/if}
                                                        </span>
                                                        {#if apagavel}
                                                            <input
                                                                type="checkbox"
                                                                id="horario-{horario.id}"
                                                                checked={horariosSelecionados.includes(horario.id)}
                                                                on:change={() => handleSelecaoHorario(horario.id)}
                                                                on:click|stopPropagation
                                                            />
                                                        {/if}
                                                    </li>
                                                {/each}
                                            </ul>
                                        </div>
                                    {/each}
                                        
                                {:else}
                                    <div class="text-center py-5">
                                        <p class="text-muted">Nenhum horário {filtroOnline === 1 ? 'Online' : 'Presencial'} disponível.</p>
                                    </div>
                                {/if}
                            </div>
                            
                            {#if apagavel && horarios.length > 0}
                                <div class="card-footer">
                                    <button class="btn btn-danger w-100" on:click={apagarHorarios}>
                                        Apagar Selecionados
                                    </button>
                                </div>
                            {/if}
                        </div>
                    {/if}

                    <div class="alert alert-info mt-4 text-center" role="alert" style="font-size: 0.9rem;">
                        <p class="mb-0">Deseja outro horário? Fale com a gente pelo <a href="https://wa.me/5581996280325?text=Olá! Gostaria de agendar uma consulta." target="_blank" class="fw-bold">Whatsapp</a></p>
                    </div>
                </div>

                {#if mostrandoModal && !apagavel}
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" on:click={fecharModal}>
                            Cancelar
                        </button>
                        <button type="button" class="btn btn-primary" on:click={confirmarAgendamento}>
                            Confirmar Agendamento
                        </button>
                    </div>
                {/if}
            </div>
        </div>
    </div>
{/if}

<CaixaDeDialogo
    tipo="confirmacao"
    titulo="Confirmação"
    on:close={() => { mensagemCaixaDialogo = ""; }}
    message={mensagemCaixaDialogo}
    button1Label={Constantes.botao_cancelar}
    button3Label={"Confirmar"}
    button3Action={confirmarAcao}
    button2Action={fecharCaixaDialogo}
    button1Action={fecharCaixaDialogo}
/>

<CaixaDeDialogo
    tipo="confirmacao"
    titulo="Confirmação"
    on:close={() => { mensagemConfirmacao = ""; }}
    message={mensagemConfirmacao}
    button1Label={"Ok"}
    button1Action={fecharModal}
/>

<CaixaDeDialogo
    tipo="confirmacao"
    titulo="Confirmação"
    on:close={() => { mensagemConfirmacao2 = ""; }}
    message={mensagemConfirmacao2}
    button1Label={"Ok"}
    button1Action={() => { mensagemConfirmacao2 = ""; }}
/>

<style>
    .agendamento-modal-overlay {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        z-index: 900;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgba(0, 0, 0, 0.4);
        backdrop-filter: blur(2px);
    }

    .agendamento-modal-content {
        background-color: #fefefe;
        padding: 0;
        border: 1px solid #888;
        border-radius: 12px;
        position: relative;
        max-width: 500px;
        width: 90%;
        margin: auto;
        box-shadow: 0 5px 15px rgba(0,0,0,0.3);
        overflow: hidden;
    }

    .modal-header {
        background-color: #f8f9fa;
        border-bottom: 1px solid #dee2e6;
        padding-top: 10px;
    }

    .modal-body {
        padding: 20px;
    }

    @media (max-width: 768px) {
        .agendamento-modal-content {
            width: 95%;
            max-width: none;
        }
    }
    
    .btn-group .btn {
        transition: all 0.3s ease;
    }
</style>